import { createGlobalStyle } from 'styled-components';
import 'bootstrap/dist/css/bootstrap.min.css';
import configs from 'configs';

const { gradient } = configs.colors;

const GlobalStyle = createGlobalStyle`

  body:before{
    content: "";
    position: absolute;
    z-index: -1;
    background: -webkit-gradient(linear, left top, right bottom, from(${gradient.from}), to(${gradient.to}))!important;
    background: linear-gradient(to bottom right, ${gradient.from}, ${gradient.to})!important;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
  }

  .content-w{
    background-color: $background-color-page !important;
  }

  strike {
    position: relative;
    text-decoration: none;
  }

  strike:before {
    position: absolute;
    content: "";
    left: 0;
    top: 50%;
    right: 0;
    border-top: 1px solid;
    border-color: inherit;

    -webkit-transform:rotate(-15deg);
    -moz-transform:rotate(-15deg);
    -ms-transform:rotate(-15deg);
    -o-transform:rotate(-15deg);
    transform:rotate(-15deg);
  }
  .text-medium{
    font-size: 1.25rem;
    margin: 0;
    padding: 0;
  }

  .element-invisible {
    margin: 0;
    padding: 0;
    width: 1px;
    position: absolute !important;
    clip: rect(1px 1px 1px 1px);
    clip: rect(1px,1px,1px,1px);
    overflow: hidden;
    height: 1px;
    color: #fff;
    background: #0a0b0b;
  }
  .element-invisible.element-focusable:active,
  .element-invisible.element-focusable:focus {
    position: static !important;
    clip: auto;
    overflow: visible;
    height: auto;
  }
`;

export default GlobalStyle;
